// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import Label from "../../../components/Label";
import SvgIconStyle from "../../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  dashboard: getIcon("ic_dashboard"),
  master: getIcon("ic_master"),
  parent: getIcon("ic_parent"),
  report: getIcon("ic_report"),
  ticket: getIcon("ic_bug"),
  orderStatus: getIcon("ic_orderStatus"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: "general",
  //   items: [
  //     {
  //       title: "Dashboard",
  //       path: PATH_DASHBOARD.general.app,
  //       icon: ICONS.dashboard,
  //     },
  //     {
  //       title: "Orders",
  //       path: PATH_DASHBOARD.general.schoolOrder,
  //       icon: ICONS.ecommerce,
  //     },
  //     {
  //       title: "Global Order Search",
  //       path: PATH_DASHBOARD.general.globalSearchOrder,
  //       icon: ICONS.ecommerce,
  //     },
  //     { title: 'Create Order', path: PATH_DASHBOARD.general.adminOrder, icon: ICONS.ecommerce },
  //     { title: 'Check Order Status', path: PATH_DASHBOARD.general.orderStatus, icon: ICONS.orderStatus },
  //     { title: 'Missing Items', path: PATH_DASHBOARD.general.tickets, icon: ICONS.ticket },
  //     {
  //       title: "Enquiry List",
  //       path: PATH_DASHBOARD.general.raisedTicket,
  //       icon: ICONS.orderStatus,
  //     },
  //   ],
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "Master",
    items: [
      // USER
      {
        title: "Master",
        path: PATH_DASHBOARD.master.root,
        icon: ICONS.master,

        children: [
          { title: "Home Slider", path: PATH_DASHBOARD.master.homeSlider},  
          { title: "Our Network", path: PATH_DASHBOARD.master.ourNetwork},
          { title: "Service", path: PATH_DASHBOARD.master.service },
        ],
      },
    ],
  },

  {
    subheader: "User",

    items: [
      // USER
      {
        title: "Contact Inquiry",
        path: PATH_DASHBOARD.general.inquiryList,
        icon: ICONS.user,
      },
    ],
  },
];

export default navConfig;
